import {
  API_REQUEST_HEADERS_BASEURL,
  API_FleetDrivers,
  API_FleetDrivers_ID_get_details,
  API_FleetDrivers_ID_delete_drivers,
} from "../utils/Constants";
import { auth } from "../firebase";

const endpoint = (template, fleetId, driverId = "") => template
  .replace("{fleetId}", encodeURIComponent(fleetId))
  .replace("{userId}", encodeURIComponent(driverId));

export async function getFleetDrivers(fleetId) {
  const response = await API_REQUEST_HEADERS_BASEURL.get(endpoint(API_FleetDrivers, fleetId), { timeout: 15000 });
  return response.data.registeredDrivers || [];
}

export async function getFleetDriver(fleetId, driverId) {
  const response = await API_REQUEST_HEADERS_BASEURL.get(endpoint(API_FleetDrivers_ID_get_details, fleetId, driverId), { timeout: 15000 });
  return response.data.data;
}

export async function removeFleetDriver(fleetId, driverId) {
  return API_REQUEST_HEADERS_BASEURL.delete(endpoint(API_FleetDrivers_ID_delete_drivers, fleetId, driverId));
}

export async function updateFleetDriverPlates(fleetId, driverId, plates, expectedPlates) {
  const response = await API_REQUEST_HEADERS_BASEURL.patch(endpoint(API_FleetDrivers_ID_get_details,fleetId,driverId),{...plates,expectedPlates});
  return response.data.data;
}

// Share refreshes between consumers; discard results after the last consumer leaves.
const subscriptions = new Map();
function subscribe(key, load, onData, onError) {
  key = `${auth.currentUser?.uid || "signed-out"}:${key}`;
  let entry = subscriptions.get(key);
  if (!entry) {
    entry = { listeners: new Set(), busy: false, stopped: false };
    subscriptions.set(key, entry);
    entry.refresh = async () => {
      if (entry.busy || entry.stopped || document.visibilityState === "hidden") return;
      entry.busy = true;
      try {
        const value = await load();
        if (!entry.stopped) entry.listeners.forEach(listener => listener.onData(value));
      } catch (error) {
        if (!entry.stopped) entry.listeners.forEach(listener => listener.onError?.(error));
      } finally { entry.busy = false; }
    };
    entry.timer = setInterval(entry.refresh, 15000);
    document.addEventListener("visibilitychange", entry.refresh);
  }
  const listener = { onData, onError };
  entry.listeners.add(listener);
  void entry.refresh();
  return () => {
    entry.listeners.delete(listener);
    if (entry.listeners.size) return;
    entry.stopped = true;
    clearInterval(entry.timer);
    document.removeEventListener("visibilitychange", entry.refresh);
    subscriptions.delete(key);
  };
}

export const subscribeFleetDrivers = (fleetId, onData, onError) =>
  subscribe(fleetId, () => getFleetDrivers(fleetId), onData, onError);
export const subscribeFleetDriver = (fleetId, driverId, onData, onError) =>
  subscribe(`${fleetId}/${driverId}`, () => getFleetDriver(fleetId, driverId), onData, onError);
